export const RESET = 'ADDRESS_LIST_RESET'
export const SET_ITEMS = 'ADDRESS_LIST_SET_ITEMS'
export const SET_ERROR = 'ADDRESS_LIST_SET_ERROR'
export const SET_VIEW = 'ADDRESS_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'ADDRESS_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/address/list/mutation_types.js